import { IShowLoaderAction } from "../interfaces/loader.interface";

export function showLoader(): IShowLoaderAction {
  return {
    type: "SHOW_LOADER",
  };
}
